import { useState } from "react";
import { PagedList } from "../../../types";
import { client } from "../../../utils/axios-client";
import NodeStore, { Chat, ChatListItem, ChatUtterance, initialEdges, initialNodes } from "../stores/NodeStore";
import { Node, Edge } from 'reactflow';

const useChats = () => {
    const chat = NodeStore.useState(s => s.chat)
    const chats = NodeStore.useState(s => s.chats);
    const isLoading = NodeStore.useState(s => s.isLoading);
    const isDirty = NodeStore.useState(s => s.isDirty);
    const [saving, setSaving] = useState(false);

    const saveChat = async () => {
        setSaving(true);
        const response = await client.post('/api/chat', chat);

        NodeStore.update(s => {
            const temp = structuredClone(chat);
        
            s.isDirty = false;
        })

        setSaving(false);
    }

    const deleteChat = async (chatId: string) => {        
        const response = await client.delete(`/api/chat`, { params: { id: chatId } });        
    }

    const generateUtterances = async (example: string) => {
        const response = await client.get(`/api/chat/utterances/generate/${example}`);
        return response.data;
    }

    const updateChatFunction = (value: boolean) => {
        NodeStore.update(s => {
            const temp = structuredClone(chat);

            temp.isFunction = value;
            s.isDirty = true;
            s.chat = temp;
        })
    }

    const updateChatName = (name: string) => {
        NodeStore.update(s => {
            const temp = structuredClone(chat);

            temp.name = name;
            s.isDirty = true;
            s.chat = temp;
        })
    }

    const addUtterances = (newUtterances: string[]) => {
        NodeStore.update(s => {
            const temp = structuredClone(chat);

            temp.utterances = [...temp.utterances, ...newUtterances.map((utterance) => ({
                id: crypto.randomUUID(),
                text: utterance
            } as ChatUtterance))]

            s.isDirty = true;
            s.chat = temp;
        })
    }


    const updateUtterances = (updatedRecords: ChatUtterance[]) => {
        NodeStore.update(s => {
            const temp = structuredClone(chat);

            temp.utterances = structuredClone(updatedRecords)

            s.isDirty = true;
            s.chat = temp;
        })
    }

    const updateUtterance = (updatedRecord: ChatUtterance) => {
        NodeStore.update(s => {
            const temp = structuredClone(chat);

            const recordIndex = temp.utterances.findIndex(s => s.id == updatedRecord.id);

            if (recordIndex > -1) {
                temp.utterances[recordIndex] = updatedRecord
            } else {
                temp.utterances.push(updatedRecord);
            }

            s.isDirty = true;
            s.chat = temp;
        })
    }


    const updateChatIntent = (intent: string) => {
        NodeStore.update(s => {
            const temp = structuredClone(chat);

            temp.intent = intent.toUpperCase().replace(' ', '');

            s.isDirty = true;
            s.chat = temp;
        })
    }

    const loadChats = async (pageNumber: number, pageSize: number, searchTerm: string, isFunction: boolean) => {
        const response = await client.get<PagedList<ChatListItem>>('/api/chat/list', { params: { pageNumber: pageNumber, pageSize, searchTerm, isFunction } });

        NodeStore.update(s => {
            s.chats = response.data;
        })
    }

    const loadChat = async (chatId: string) => {
        const response = await client.get<Chat>('/api/chat', { params: { id: chatId } });

        NodeStore.update(s => {
            s.isDirty = false;
            s.isLoading = true;
            s.chat = response.data;
        })
    }
    //structuredClone(initialNodes),
    //structuredClone(initialEdges)


    const newChat = () => {
        const newChat = {
            id: crypto.randomUUID(),
            name: '',
            intent: '',
            isFunction: false,
            published: false,
            isDeleted: false,
            nodes: [] as Node[],
            edges: [] as Edge[],
            utterances: []
        } as Chat

        NodeStore.update(s => {
            s.chat = newChat;
        })

        return newChat;
    }

    return {
        saveChat,
        chat,
        chats,
        updateChatName,
        updateChatIntent,
        loadChats,
        loadChat,
        newChat,
        saving,
        addUtterances,
        updateUtterances,
        updateUtterance,
        updateChatFunction,
        isDirty,
        deleteChat,
        isLoading,
        generateUtterances
    }
}

export default useChats;